export default "__VITE_ASSET__E5xRu4qu__"